import { motion } from "framer-motion";

export default function SectionHeading({ title, subtitle, centered = true, light = false, badge, className = "" }) {
  return (
    <div className={`mb-12 ${centered ? "text-center" : ""} ${className}`}>
      {/* {badge && (
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="inline-block px-4 py-1 rounded-full text-sm font-semibold mb-4"
          style={{ background: "var(--gradient-gold)", color: "var(--color-primary-dark)" }}
        >
          {badge}
        </motion.span>
      )} */}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${light ? "text-white" : "text-slate-800"}`}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className={`text-lg max-w-7xl ${centered ? "mx-auto" : ""} ${light ? "text-white/80" : "text-slate-500"}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
